import { styled } from '@mui/material/styles';

const PREFIX = 'LineClamp';

const classes = {
  lineClamp: `${PREFIX}-lineClamp`
};

const Root = styled('div')(() => ({
  [`&.${classes.lineClamp}`]: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: ({ lineClamp }) => lineClamp,
    lineClamp: ({ lineClamp }) => lineClamp,
    whiteSpace: 'break-spaces!important' as 'break-spaces'
  }
}));

export interface StyleProps {
  lineClamp?: number;
}

export interface Props extends StyleProps {
  text: string;
}

/**
 * Component that truncates the text at a specific number of lines.
 * @param lineClamp - maximum number of visible lines
 * @param text - text
 */
const LineClamp = ({ text }: Props) => {
  return <Root className={classes.lineClamp}>{text}</Root>;
};

export default LineClamp;
